module.exports = __webpack_public_path__ + "static/media/Rayna T.0f56fa05.jpg";